import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../../analytics.const';

import type { GalleryEvent } from './types';

const { GALLERY } = ANALYTICS_CATEGORIES;

export const triggerGalleryThumbClickedEvent = ({ kind }: GalleryEvent): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GALLERY,
		customData: { label: kind },
		name: 'dlr_hero_gallery_thumbnail_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
